<div class="outline">
    <ng-container *ngFor="let chapter of treeData">
        <ng-template #recursiveList let-list>
            <ul>
                <li class="outline-item-li" *ngFor="let item of list"
                    [class.cursorPointer]="listClickable">
                    <p id="{{item.unitOrder}}" *ngIf="item.informationUnitTitle !== ''"
                       [tabIndex]="item.unitOrder === currentUnitOrderId ? 0 : -1"
                       [class.basicLi]="item.status === 'UNMARKED'"
                       [class.understoodLi]="item.status === 'UNDERSTOOD'"
                       [class.cursorPointer]="item.status === 'UNDERSTOOD'"
                       [class.skippedLi]="item.status === 'SKIPPED'"
                       [class.activeLi]="item.unitOrder === currentUnitOrderId"
                       [class.boldLi]="item.unitLevel === 'A'"
                       [class.commentedLi]="markUnitIfItHasComments(item.informationUnitTitle)"
                       [innerHTML]="stripTagsFromString(item.informationUnitTitle)"
                       [attr.aria-label]="item.informationUnitTitle"
                       (click)="elementClicked(item)"
                       (keyup)="onKeyUp($event, item)"
                       (keydown)="onKeyDown($event)">

                        {{item.informationUnitTitle}}
                    </p>
                    <p *ngIf="!item.informationUnitTitle || item.informationUnitTitle === ''" class="untitled"
                       [tabIndex]="item.unitOrder === currentUnitOrderId ? 0 : -1"
                       [class.basicLi]="item.status === 'UNMARKED'"
                       [class.cursorPointer]="item.status === 'UNDERSTOOD'"
                       [class.activeLi]="item.unitOrder === currentUnitOrderId"
                       [class.boldLi]="item.unitLevel === 'A'"
                       [attr.aria-label]="item.informationUnitTitle"
                       (click)="elementClicked(item)"
                       (keyup)="onKeyUp($event, item)"
                       (keydown)="onKeyDown($event)">
                        {{noTitle}}
                    </p>
                    <!--                                    <span class="text">{{ item.unitLevel }} _ {{ item.unitRelevance }} _ {{ item.unitOrder }}</span>-->
                    <!--                                    <span class="text">next ({{ item.goAhead}}) skip ({{item.skipTo}})</span>-->
                    <ng-container
                            *ngIf="item.children.length > 0">
                        <ng-content
                                *ngTemplateOutlet="recursiveList; context:{ $implicit: item.children }">
                        </ng-content>
                    </ng-container>

                </li>
            </ul>
        </ng-template>
        <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: chapter.units }"></ng-container>
    </ng-container>
</div>
